import CCColors from '../../Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  eachVariation: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(38, 35, 34, 0.06)',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  switchBox: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: 'transparent',
    borderCurve: 'circular',
    marginTop: 5,
  },
  reviewEngineBox: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 11,
    backgroundColor: '#FAF6EB',
    marginBottom: 5,
    marginTop: 5,
  },
  reviewEngineIcon: {
    width: 28,
    height: 28,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E1F3EF',
  },
  reviewEngineText: {
    flex: 1,
    minWidth: 0,
  },
  reviewEngineTitle: {
    color: '#262322',
    fontSize: 13,
    fontWeight: '900',
    lineHeight: 17,
  },
  reviewEngineSub: {
    color: '#73695F',
    fontSize: 11,
    lineHeight: 15,
  },
});
